import CodeMirror, { type UseCodeMirror } from "@uiw/react-codemirror";
import { clsx } from "clsx";
import { type CSSProperties, type FC, useRef } from "react";
import { useResizeObserver } from "widgets/hooks";

interface FilePreviewTextFieldProps extends Pick<UseCodeMirror, "value"> {
  isLoading?: boolean;
  style?: CSSProperties;
}

export const FilePreviewTextField: FC<FilePreviewTextFieldProps> = (props) => {
  const contentSizeRef = useRef<HTMLDivElement>(null);
  const contentBoxSize = useResizeObserver(contentSizeRef);

  return (
    <div
      className={clsx("cm-script-editor", { "cm-disabled": props.isLoading })}
      style={{ ...props.style, overflow: "hidden" }}
      data-testid="text-file-preview"
      ref={contentSizeRef}
    >
      <CodeMirror
        width={contentBoxSize?.width ? `${contentBoxSize?.width}px` : undefined}
        height={contentBoxSize?.height ? `${contentBoxSize?.height - 2}px` : undefined}
        value={props.isLoading ? "Please wait..." : props.value}
        readOnly
        autoFocus={false}
      />
    </div>
  );
};
